import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pessoa: {
    nome: "John Doe",
    email: "johndoe@gmail.com",
    ativo: true,
  },
};

const wikiSlice = createSlice({
  name: "wiki",
  initialState,
  reducers: {
    salvarEstado(state, action) {
      state.pessoa = { ...action.payload };
    },
  },
});

export const wikiActions = wikiSlice.actions;

export default wikiSlice.reducer;
